import { Object } from "@baseline/common";
import { Config } from "./config";


export class ConfigurationService<T extends Config = Config> {
    constructor(config: T) {
        this.config = config;
    }

    get(key: string): any {
        return Object.get(this.config, key);
    }

    readonly config: T;
}

